import {useState} from 'react'
import {msg, t, Trans} from '@lingui/macro'
import {styled} from '@mui/material/styles'
import {Box, IconButton} from '@mui/material/'
import DesktopNav from '../../components/desktop/DesktopNav'
import Dashboard from "../../components/data-analysis/charts/Dashboard";
import CrashList from "../../components/data-analysis/CrashList";
import CustomChart from "../../components/data-analysis/charts/CustomChart";
import DesktopToolbar from "../../components/desktop/DesktopToolbar";
import {Typography, useTheme} from "@mui/material";
import SvgCustomIcon from "../../components/icons/SvgCustomIcon";
import {useLingui} from '@lingui/react'

/*
  - Crash
  Collected by
  Officer Name/Operator Name
  Officer Department/Operator Hospital
  Date of Filling <----> Until <---->
  Crash date <----> Until <---->
  Crash month
  Light conditions
  Crash type
  ADaMS crash id
  Officer position
  Officer number
  Report number
  Report date <----> Until <---->
  Crash week day
  Wheather conditions
  Vehicle runaway
  Severity
*/

// eslint-disable-next-line no-restricted-globals
const statsBaseUrl = new URL('/api/statistics', location)

// eslint-disable-next-line no-restricted-globals
const allPublicCrashesUrl = new URL('/api/public_crash/list', location)





const ExpandMore = styled(props => {
    const {expand, ...other} = props
    return <IconButton {...other} />
})(({theme}) => ({
    marginLeft: 'auto'
    , transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
    })
    , variants: [
        {
            props: ({expand}) => !expand
            , style: {
                transform: 'rotate(0deg)'
            }
        }
        , {
            props: ({expand}) => !!expand
            , style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
}));





export default function Statistics({position, isMobile, handleRowClick}) {
    const [showSub, setShowSub] = useState('crashList')
    const theme = useTheme()
    const {i18n} = useLingui()

    const iconSizeStyle = {
        height: 20,
        width: 20
    }

    const subPanelElements = [
        {
            label: t`Crash list`
            , icon: <SvgCustomIcon name={'list'}/>
            , type: 'button'
            , onMobile: false
            , access: [0, 1, 2]
            , action: () => setShowSub('crashList')
        }

        , {
            label: t`Dashboard`
            , icon: <SvgCustomIcon name={'dashboard'}/>
            , type: 'button'
            , onMobile: false
            , access: [0, 1, 2]
            , action: () => setShowSub('charts')
        }
        , {
            label: t`Custom charts`
            , icon: <SvgCustomIcon name={'barChart4'}/>
            , type: 'button'
            , onMobile: false
            , access: [0, 1, 2]
            , action: () => setShowSub('customCharts')
        }
    ]

    console.log('show sub ', showSub)

    const subTitle =
        showSub === 'crashList'
            ? msg`Crash list`
            : showSub === 'charts'
                ? msg`Dashboard`
                : msg`Custom charts`;

    return (
        <Box component="main">
            <DesktopNav position={position} subPanelElements={subPanelElements}/>
            <DesktopToolbar/>
            <Box sx={{p:2}}>

                <Box sx={{ml: `${theme.mixins.drawerWidth}px`,p:1,borderBottom: `1px solid ${theme.palette.newColors.gray}`}}>
                    <Typography sx={{color: theme.palette.mode === 'light' ? theme.palette.newColors.gray : theme.palette.newColors.lightGray,fontWeight:'bold',fontSize:24}}>
                        <Trans>Data Analysis</Trans>
                    </Typography>
                </Box>
                <Box sx={{ml: `${theme.mixins.drawerWidth}px`,p:1}}>
                    <Typography sx={{textTransform:'uppercase',color: theme.palette.mode === 'light' ? theme.palette.newColors.gray : theme.palette.newColors.lightGray,fontWeight:'bold',fontSize:18}}>
                        <Trans>  {i18n._(subTitle)}</Trans>
                    </Typography>
                </Box>
                {
                    {
                        crashList: <CrashList isMobile={isMobile} handleRowClick={handleRowClick}/>
                        , charts: <Dashboard isMobile={isMobile}/>
                        , customCharts: <CustomChart isMobile={isMobile}/>
                    }[showSub]
                }
            </Box>
        </Box>
    )
}
